import { type FirebaseOptions } from "firebase/app";

type IngredifindConfig = {
  firebase: FirebaseOptions;
  dashboardUrl: string;
};

export const config = {
  dashboardUrl: "https://dashboard.ingredifind.com",
  firebase: {
    apiKey: "AIzaSyDF2pMSIrrR1SS7triOwSCmjAUleFlCxQc",
    authDomain: "igfd-mobile.firebaseapp.com",
    projectId: "igfd-mobile",
    storageBucket: "igfd-mobile.firebasestorage.app",
    messagingSenderId: "65313590455",
    appId: "1:65313590455:web:630e80980df38b0ac4d132",
    measurementId: "G-KWZXPLWRYM",
  },
} as IngredifindConfig;
